<template lang="html">
  <nav
    class="lk_navigation"
    :class="{ 'no-scroll': subMenu !== false }"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
    :style="colorStyle"
  >
    <transition name="sub-menu" mode="out-in">
      <div class="lk_navigation__sub-menu sub-menu" v-if="subMenu !== false">
        <a class="company__block flex-auto" href="https://bimlib.pro/" data-vue-tour-step="1">
          <template v-if="getName === 'BIMLIB'">
            <IconCompanyLogoDefault v-if="isHovered === false" class="company__logo" />
            <div
              v-else
              class="company__logo-extend"
              v-html="require('@/assets/img/bim-logo.svg')"
            />
          </template>
          <img
            v-else-if="companyLogo"
            class="company__logo"
            :src="companyLogo"
            alt="company__logo"
          />
          <template v-else>
            <IconCompanyLogoDefault v-if="isHovered === false" class="company__logo" />
            <div
              v-else
              class="company__logo-extend"
              v-html="require('@/assets/img/bim-logo.svg')"
            />
          </template>
        </a>
        <div @click="subMenu = false" class="sub-menu__back menu__li">
          <IconArrow class="icon icon-back" />
          <span class="menu__li-text">{{ subMenuItem.name }}</span>
        </div>
        <a
          v-for="item in subMenuItem.item"
          :key="item.name"
          :href="formLink(item.link)"
          class="menu__li"
          :class="{ active: isActive(item.link) }"
        >
          <component :is="item.icon" class="icon" />
          <span class="menu__li-text">{{ item.name }}</span>
        </a>
      </div>
    </transition>
    <!--Изменение компании-->
    <div v-if="showPopupChangeCompany" class="companies__block">
      <div class="companies__block__popup">
        <div
          class="close_img"
          @click="showPopupChangeCompany = false"
          v-html="require('@/assets/img/icon-close-black.svg')"
        />
        <div class="companies__block__data" :class="{ loading: isLoading }">
          <div class="main-company-text">
            {{ $bimTranslate("header.selectCompany", activeLang) }}
          </div>

          <div
            v-for="company in companies"
            :key="company.id"
            class="company__item mt-9"
            :class="{ active: activeCompanyId === company.id }"
            @click="companyClicked(company.id)"
          >
            <div class="company__item__logo" :class="{ empty: !getCompanyLogo(company) }">
              <img
                v-if="getCompanyLogo(company)"
                class="img__cmp"
                :src="getCompanyLogo(company)"
                alt
              />
              <div v-else class="empty__company" v-html="require('@/assets/img/noPic.svg')" />
            </div>
            <div class="company__name">
              {{ company.nameShort }}
            </div>
          </div>

          <div
            class="company__item mt-9"
            :class="{ active: hasNoCurrentCompany }"
            @click="resetCompany"
          >
            <div class="company__item__logo">
              <div class="empty__company" v-html="require('@/assets/img/noPic.svg')" />
            </div>
            <div class="company__name">
              {{ $bimTranslate("header.withoutCompany", activeLang) }}
            </div>
          </div>

          <bim-button
            class="mt-9"
            width="100%"
            :label="$bimTranslate('header.manageCompany', activeLang)"
            size="l"
            color="gray"
            @click="clickedGoCompany"
          />
        </div>
      </div>
    </div>

    <div class="header__2 flex flex-column">
      <a class="company__block flex-auto" href="https://bimlib.pro/" data-vue-tour-step="1">
        <template v-if="getName === 'BIMLIB'">
          <IconCompanyLogoDefault v-if="isHovered === false" class="company__logo" />
          <div v-else class="company__logo-extend" v-html="require('@/assets/img/bim-logo.svg')" />
        </template>
        <img v-else-if="companyLogo" class="company__logo" :src="companyLogo" alt="company__logo" />
        <template v-else>
          <IconCompanyLogoDefault v-if="isHovered === false" class="company__logo" />
          <div v-else class="company__logo-extend" v-html="require('@/assets/img/bim-logo.svg')" />
        </template>
      </a>
      <div class="lk_navigation__main flex-item flex-grow-1">
        <div class="menu__block">
          <ul class="menu__ul">
            <a class="menu__li" :class="{ active: isActive('/') }" :href="formLink('/')">
              <Dashboard class="icon" />
              <span class="menu__li-text">Дашборд</span>
            </a>

            <!-- BIM -->
            <a
              class="menu__li"
              :class="{ active: isActive('/models/') }"
              data-vue-tour-step="3"
              :href="formLink('/models/')"
            >
              <IconBIM class="icon" /> <span class="menu__li-text">Модели</span>
            </a>

            <!-- Маркетинг -->
            <a
              class="menu__li"
              :class="{ active: isActive('/plugins/') }"
              data-vue-tour-step="4"
              :href="formLink('/plugins/')"
            >
              <IconPlugins class="icon" />
              <span class="menu__li-text">Плагины</span>
            </a>

            <!-- Цифровой каталог -->
            <li class="menu__li" @click="subMenu = 'marketing'">
              <IconMarketing class="icon" /> <span class="menu__li-text">Маркетинг</span>
              <IconArrow class="icon-extra" />
            </li>

            <a
              class="menu__li"
              :class="{ active: isActive('/statistic/users/') }"
              :href="formLink('/statistic/users/')"
            >
              <IconStats class="icon" /> <span class="menu__li-text">Статистика</span>
            </a>

            <a
              class="menu__li"
              :class="{ active: isActive('/statistic/company/email/') }"
              :href="formLink('/statistic/company/email/')"
            >
              <IconStats class="icon" /> <span class="menu__li-text">Статистика компании</span>
            </a>

            <!-- Партнерская программа -->
            <a
              v-if="isUserManufacturer"
              :class="{ active: isActive('/partnership') }"
              :href="formLink('/partnership')"
              class="menu__li"
              @click="logActionEvent('LKLeftMenuPartnership')"
            >
              <IconLightning class="icon" />
              <span class="menu__li-text">Партнерская программа</span>
            </a>
          </ul>
        </div>
      </div>
      <div class="lk_navigation__main">
        <div class="menu__block">
          <ul class="menu__ul">
            <a
              class="menu__li"
              :class="{ active: isActive('/profile/') }"
              :href="formLink('/profile/')"
            >
              <Avatar v-if="user.avatar" :user="user" :img-host="imgHost" />
              <IconProfile v-else class="icon" />
              <span class="menu__li-text">{{ user.firstName }} {{ user.lastName.at(0) }}.</span>
              <IconArrow class="icon-extra" />
            </a>
            <a class="menu__li" :href="formLink('/companies?tab=basicData')">
              <img
                v-if="companyLogo"
                :src="companyLogo"
                alt="company__logo"
                width="25"
                height="25"
              />
              <span class="menu__li-text">{{ getName || "Компания" }}</span>
              <IconArrow class="icon-extra" />
            </a>
          </ul>
        </div>
      </div>
      <div class="lk_navigation__main">
        <div class="menu__block">
          <ul class="menu__ul">
            <a class="menu__li" href="javascript://" @click="$emit('logoutClicked')">
              <IconLogout class="icon" /> <span class="menu__li-text">Выйти из аккаунта</span>
            </a>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import bimButton from '@/components/form/bimButton/bimButton'

// import NoticeCount from '@/components/core/ui/notice-count'
import IconMarketing from '@/components/core/bimLeftMenu/icons/Marketing'
import IconBIM from '@/components/core/bimLeftMenu/icons/BIM'
import IconTV from '@/components/core/bimLeftMenu/icons/TV'
import IconNetwork from '@/components/core/bimLeftMenu/icons/Network'
import IconCodeBlock from '@/components/core/bimLeftMenu/icons/CodeBlock'
import IconBook from '@/components/core/bimLeftMenu/icons/Book'
// import IconExtra from '@/components/core/bimLeftMenu/icons/Extra'
// import IconPP from '@/components/core/bimLeftMenu/icons/PP'
// import IconDCatalog from '@/components/core/bimLeftMenu/icons/DCatalog'
// import IconModels from '@/components/core/bimLeftMenu/icons/Models'
// import IconEmbed from '@/components/core/bimLeftMenu/icons/Embed'
// import IconPlans from '@/components/core/bimLeftMenu/icons/Plans'
import IconStats from '@/components/core/bimLeftMenu/icons/Stats'
import IconPlugins from '@/components/core/bimLeftMenu/icons/Plugins'
// import IconArticles from '@/components/core/bimLeftMenu/icons/Articles'
// import IconVideos from '@/components/core/bimLeftMenu/icons/Videos'
// import IconProducts from '@/components/core/bimLeftMenu/icons/Products'
// import IconNTD from '@/components/core/bimLeftMenu/icons/NTD'
// import IconProperties from '@/components/core/bimLeftMenu/icons/Properties'
// import IconDeposit from '@/components/core/bimLeftMenu/icons/Deposit'
// import IconSale from '@/components/core/bimLeftMenu/icons/Sale'
import IconSettings from '@/components/core/bimLeftMenu/icons/Settings'
// import IconDocument from '@/components/core/bimLeftMenu/icons/Document'
// import IconMap from '@/components/core/bimLeftMenu/icons/Map'
import IconCompanyLogoDefault from '@/components/core/bimLeftMenu/icons/CompanyLogoDefault'
// import IconCompany from '@/components/core/bimLeftMenu/icons/Company'
import IconProfile from '@/components/core/bimLeftMenu/icons/Profile'
// import IconSupport from '@/components/core/bimLeftMenu/icons/Support'
import Dashboard from '@/components/core/bimLeftMenu/icons/Dashboard'
import Avatar from '@/components/core/bimHeader/Avatar'
import IconLogout from '@/components/core/bimLeftMenu/icons/Logout'
import IconLightning from '@/components/core/bimLeftMenu/icons/Lightning'
import IconArrow from '@/components/core/bimLeftMenu/icons/Arrow'

import { getValue } from '@/utils/helpers'

export default {
  name: 'BimLeftMenu',
  components: {
    // NoticeCount,
    IconTV,
    IconNetwork,
    IconBook,
    IconArrow,
    IconLogout,
    bimButton,
    IconMarketing,
    IconBIM,
    IconSettings,
    // IconExtra,
    // IconPP,
    // IconDCatalog,
    // IconEmbed,
    // IconPlans,
    IconStats,
    IconPlugins,
    // IconModels,
    // IconArticles,
    // IconVideos,
    // IconProducts,
    // IconNTD,
    // IconProperties,
    // IconDeposit,
    // IconSale,
    // IconDocument,
    // IconMap,
    IconCompanyLogoDefault,
    Avatar,
    Dashboard,
    // IconCompany,
    IconProfile,
    // IconSupport,
    IconLightning,
    IconCodeBlock,
  },
  props: {
    logActionEvent: {
      type: Function,
      default: () => {}
    },
    /**
     * Основной цвет
     */
    primaryColor: {
      type: String,
      default: '#00afa1',
    },

    /**
     * Объект пользователя
     * user { avatar: String, count_new_message: Number, firstName: String, lastName: String }
     */
    user: {
      type: Object,
      default: () => ({}),
    },

    /**
     * для ГИСП системы
     */
    isGISP: {
      type: Boolean,
      default: false,
    },

    /**
     * Префикс до изображений Аватарки и логотипа компании
     */
    imgHost: {
      type: String,
      default: '/api/assets/images/',
    },

    /**
     * Адрес основного домена (использовать если домен отличается от основного сайта)
     */
    bimlibHost: {
      type: String,
      default: '',
    },

    /**
     * Текущий язык
     */
    activeLang: {
      type: String,
      default: 'ru',
      validator (value) {
        return ['ru', 'en'].indexOf(value) !== -1
      },
    },
    /**
     * Показан/спрятан попап компаний
     */
    showCompanyListPopup: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      activeGroup: '',
      leaveTimeout: null,
      isLoading: false,
      showPopupChangeCompany: false,
      isHovered: false,
      subMenu: false,
      subMenuItems: {
        marketing: {
          name: 'Маркетинг',
          item: [
            {
              icon: IconBook,
              name: 'Статьи',
              link: '/articles/',
            },
            {
              icon: IconTV,
              name: 'Видеоролики',
              link: '/companies?tab=video',
            },
            {
              icon: IconNetwork,
              name: 'Интеграции',
              link: '/companies?tab=integrations',
            },
            {
              icon: IconCodeBlock,
              name: 'Код для встраивания',
              link: '/models/catalogue/',
            },
          ],
        },
      },
    }
  },
  computed: {
    subMenuItem () {
      return this.subMenuItems[this.subMenu]
    },
    isUserManufacturer () {
      const { currentCompany } = this.user
      return this.userContext.role === 'manufacturer' || +currentCompany.categoryCode === 1
    },
    /**
     * Поле context пользователя
     */
    userContext () {
      return (this.user || {}).context
    },
    colorStyle () {
      return {
        '--primarycolor': this.primaryColor,
      }
    },

    /**
     * условие показа значка СМПП
     */
    showResourceModule () {
      return getValue(this.user, 'currentCompany.id', '').length > 0
    },

    /**
     * условие показа кол-во уведомлений для смпп
     */
    showDemoSmppNotice () {
      const { permissions = [] } = this.resourcesModule() || {}
      const { smppDemoContactsLeft } = this.userContext
      return (
        (permissions.includes('DEMO') && typeof smppDemoContactsLeft === 'number') ||
        smppDemoContactsLeft === 0
      )
    },

    hasNoCurrentCompany () {
      const { currentCompany } = this.user || {}

      if (currentCompany && !currentCompany.id) {
        return true
      }

      return !currentCompany
    },

    activeCompanyId () {
      const { currentCompany } = this.user || {}
      return currentCompany ? currentCompany.id : null
    },

    companies () {
      const items = getValue(this.user, 'employments', [])

      const companies = items.map((item) => item.company)

      return companies.filter((item) => item.nameShort)
    },

    companyLogo () {
      const { currentCompany } = this.user || ''

      if (!currentCompany) {
        return
      }

      return this.getCompanyLogo(currentCompany)
    },
    getName () {
      const { currentCompany } = this.user || ''

      if (!currentCompany) {
        return
      }

      return currentCompany.nameShort
    },
  },
  watch: {
    showCompanyListPopup (newVal) {
      if (newVal && this.companies.length < 1) {
        this.$emit('update:showCompanyListPopup', false)
        this.route('/companies')

        return
      }
      if (newVal === undefined || newVal === this.showPopupChangeCompany) return

      this.showPopupChangeCompany = newVal
    },
    showPopupChangeCompany (newVal) {
      if (newVal === this.showCompanyListPopup) return

      this.$emit('update:showCompanyListPopup', newVal)
    },
    subMenu (newVal) {
      if (newVal !== false) {
        const navElement = document.querySelector('.lk_navigation')
        if (navElement) {
          navElement.scrollTop = 0
        }
      }
    },
  },
  mounted () {
    this.popupListenerHandler()
  },
  beforeDestroy () {
    this.popupListenerHandler(true)
  },
  methods: {
    isActive (route) {
      return window.location.pathname === route
    },
    popupListenerHandler (remove) {
      const closePopup = (event) => {
        const isBackdrop = event.target.classList.contains('companies__block')
        if (!isBackdrop) return

        this.showPopupChangeCompany = false
      }
      const body = document?.body

      if (remove) body.removeEventListener('click', closePopup)
      else body.addEventListener('click', closePopup)
    },
    companyLogoClicked () {
      if (this.companies.length < 1) {
        this.route('/companies')
      } else {
        this.showPopupChangeCompany = !this.showPopupChangeCompany
      }
    },

    onOver (group) {
      clearTimeout(this.leaveTimeout)
      this.activeGroup = group
    },

    onMenuOver () {
      clearTimeout(this.leaveTimeout)
    },

    onLeave () {
      this.leaveTimeout = setTimeout(() => {
        this.activeGroup = ''
      }, 300)
    },

    route (path, event) {
      if (this.$router && !this.bimlibHost) {
        if (event) {
          event.preventDefault()
        }

        this.$router.push(path)
        this.activeGroup = ''
      } else {
        window.location = `${this.bimlibHost || ''}${path}`
      }
    },

    getCompanyLogo (company) {
      if (!company.logo) {
        return null
      }

      return `${this.imgHost}${company.logo}`
    },

    clickedGoCompany () {
      this.route('/companies')
      this.showPopupChangeCompany = false
    },

    // поменять активную компанию
    async companyClicked (companyId) {
      try {
        this.isLoading = true

        await this.$user.setCompany(companyId)

        setTimeout(() => {
          window.location.href = this.isGISP ? '/bimlib' : '/'
        }, 300)
      } finally {
        this.isLoading = false
        this.showPopupChangeCompany = false
      }
    },

    // без компании
    async resetCompany () {
      try {
        this.isLoading = true

        // сбросим компанию
        await this.$user.resetCompany()

        setTimeout(() => {
          window.location.href = this.isGISP ? '/bimlib' : '/'
        }, 300)
      } finally {
        this.isLoading = false
        this.showPopupChangeCompany = false
      }
    },

    producerModule () {
      return this.modulePermission('PRODUCER')
    },

    resourcesModule () {
      return this.modulePermission('RESOURCES')
    },

    modulePermission (module) {
      return this.$user.contextModulePermissions(this.user, module)
    },

    formLink (path) {
      return `${this.bimlibHost}${path}`
    },
  },
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.sub-menu-enter-active {
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
  z-index: 1; /* Перекрывает другой контент */
}

.sub-menu-enter {
  transform: translateX(100%); /* Начальное положение за пределами экрана */
  opacity: 0;
}

/* Класс для анимации закрытия */
.sub-menu-leave-active {
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
  z-index: 1; /* Перекрывает другой контент */
}

.sub-menu-leave-to {
  transform: translateX(100%); /* Конечное положение за пределами экрана */
  opacity: 0;
}

::v-deep * {
  &,
  &:before,
  &:after {
    transition: none !important;
  }
}

::v-deep svg {
  display: unset;
  height: unset;
  width: unset;
}

.lk_navigation {
  background: #fff;

  box-shadow: 0px 15px 20px 0px #e5eceb;
  position: fixed;
  top: 0;
  bottom: 0;
  height: 100%;
  left: 0;
  width: 64px;
  padding: 23px 6px;
  overflow: hidden;
  -webkit-transition: width 0.05s linear;
  transition: width 0.05s linear;
  -webkit-transform: translateZ(0) scale(1, 1);
  z-index: 1001;
  -ms-overflow-style: none; /* IE и Edge */
  scrollbar-width: none; /* Firefox */

  &.no-scroll {
    overflow: hidden !important;
  }
}

.lk_navigation::-webkit-scrollbar {
  display: none;
}

.lk_navigation:hover {
  width: 300px;
  overflow: visible;
  overflow-y: scroll;

  & .menu__li {
    width: 100%;
    -webkit-transition: width 0.05s linear;
    transition: width 0.05s linear;
    -webkit-transform: translateZ(0) scale(1, 1);
  }
  & .menu__li-text {
    display: block;
    margin-left: 8px;
  }

  & .icon-extra {
    display: block;
  }
}

.lk_navigation__main {
  padding-bottom: 16px;
  border-bottom: 1px solid #eaeaea;

  &:last-child {
    border: none;
  }
}

.lk_navigation__sub-menu {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  z-index: 100;
}

.sub-menu__back {
  display: flex;
  align-items: center;
}

.bimlib__logo {
  padding: 14px 0;
  text-align: center;
  cursor: pointer;
  opacity: 0.5;
  line-height: 1px;
}

.bimlib__logo:hover {
  opacity: 1;
}

.bimlib__logo svg {
  fill: #4d4d4d;
  height: 10px;
}

.bimlib__logo:hover svg {
  fill: #00afa1;
}

.header__2 {
  margin: 7px 0;
}

.company__block {
  display: block;
  height: 80px;
  position: relative;
  background-color: #fff;
  cursor: pointer;

  border-bottom: 1px solid #eaeaea;
}

.company__logo {
  max-width: 60px;
  max-height: 60px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  fill: #00afa1;

  &-extend {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    display: block;
    fill: #00afa1;
  }
}

.menu__ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.menu__li {
  position: relative;
  display: flex;
  align-items: center;
  width: 54px;
  cursor: pointer;
  padding: 12px;

  border-radius: 8px;

  &.active {
    background: var(--bg-island-inner, rgba(61, 204, 187, 0.05));

    & .menu__li-text {
      color: #4eaca1;
    }
    & .icon,
    & .icon path {
      fill: #4eaca1 !important;
    }
  }
}

.menu__li:first-child {
  margin-top: 16px;
}

.menu__li-notice {
  top: 30%;
  left: 60%;
}

.icon {
  display: block;
  color: #4d4d4d;
  fill: #4d4d4d;
  width: 28px;
  height: 28px;
}

.icon-extra {
  display: none;
  position: absolute;
  right: 0;
}

.icon-back {
  transform: rotate(180deg);
}

.menu__li-link {
  display: block;
  width: 100%;
  height: 100%;
}

.menu__li:hover {
  background-color: #f2f2f2;
}

.menu__li:hover .icon {
  opacity: 1;
  fill: var(--primarycolor);
  color: var(--primarycolor);
}

.menu__li.active .icon {
  color: var(--primarycolor);
  fill: var(--primarycolor);
  opacity: 1;
}

.menu__li-text {
  position: relative;
  display: none;

  color: #192724;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.014px;
}

.profile__menu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ava__circle {
  display: block;
  width: 42px;
  height: 42px;
  background-color: #e8edff;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
}

.ava__circle:hover {
  opacity: 0.7;
}

.inner__menu {
  position: absolute;
  top: 0;
  left: 80px;
  width: 195px;
  bottom: 0;
  background-color: #f6f6f6;
  z-index: 41;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.05);
  border-right: 1px solid #eeeeee;
}

.v-tour--background-menu .inner__menu::after {
  content: "";
  width: calc(100% + 1px);
  position: absolute;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
}

.inner__ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
  width: 195px;
}

.inner__li,
.inner__title {
  background-color: white;
  height: 80px;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.57;
  letter-spacing: 0.2px;
  position: relative;
  border: 1px solid #f2f2f2;
  padding-left: 62px;
  padding-right: 25px;
}

.inner__li:hover {
  cursor: pointer;
  background-color: #f6f6f6;
}

.inner__li:hover a {
  color: var(--primarycolor);
}

.inner__li a::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.inner__li .inner__icon {
  opacity: 0.5;
  fill: black;
  color: black;
}
.inner__li:hover .inner__icon {
  opacity: 1;
  fill: var(--primarycolor);
  color: var(--primarycolor);
}

.menu__li + .menu__li,
.inner__li + .inner__li {
  margin-top: 4px;
}

.inner__title {
  background-color: inherit;
  border: none;
  width: 100%;
  padding: 0;
}

.inner__title--link {
  display: flex;
  height: 100%;
  width: 100%;

  &:hover {
    color: var(--primarycolor);
  }
}

.text-title {
  display: flex;
  align-items: flex-end;
  padding-top: 0;
  padding-left: 24px;
  font-size: 15px;
  font-weight: bold;
  line-height: 20px;
  letter-spacing: 0.2px;
}

.inner__icon {
  position: absolute;
  top: 26px;
  left: 24px;
  opacity: 0.7;
  width: 24px;
  height: 24px;
}

.companies__block {
  position: fixed;
  top: 0;
  left: 80px;
  right: 0;
  bottom: 0;
  z-index: 40;
  background-color: rgba(0, 0, 0, 0.25);
}

.companies__block__popup {
  position: absolute;
  top: 38px;
  left: 24px;
  border-radius: 5px;
  box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.15);
  background-color: white;
  padding: 24px;
  width: 445px;
  box-sizing: border-box;
  min-height: 250px;
  max-height: 600px;
  overflow-y: auto;
}

.companies__block__data.loading {
  opacity: 0.5;
  pointer-events: none;
}

.close_img {
  position: absolute;
  top: 24px;
  right: 24px;
  display: block;
  width: 16px;
  opacity: 0.25;
  transition: opacity 0.45s;
}

.close_img:hover {
  cursor: pointer;
  opacity: 1;
}

.company__item:after {
  display: block;
  clear: both;
  content: "";
}

.company__item + .company__item {
  margin-top: 14px;
}

.company__item:hover {
  cursor: pointer;
}

.company__item:hover .company__name,
.company__item.active .company__name {
  color: var(--primarycolor);
}

.company__item__logo {
  width: 42px;
  height: 42px;
  float: left;
  position: relative;
}

.company__item__logo .empty__company {
  background-color: white;

  ::v-deep svg {
    margin: auto;
    display: block;
    top: 8px;
    position: relative;
  }
}

.img__cmp {
  display: block;
  max-width: 42px;
  max-height: 42px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.company__name {
  overflow: hidden;
  padding-left: 13px;
  font-size: 14px;
  line-height: 42px;
  font-weight: bold;
}

a {
  text-decoration: none;
  color: #3f3f3f;
}

.main-company-text {
  font-size: 18px;
  line-height: 1.44;
  letter-spacing: normal;
  font-weight: bold;
}

.flex {
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-wrap: nowrap;
}

.flex-item {
  flex: 1;
}

.flex-auto {
  flex: 0 0 auto;
}

.user-avatar {
  width: 25px;
  height: 25px;
  margin: 0;
}
</style>
